<template>
  <v-alert
    dense
    outlined
    :type="type"
    class="ma-0"
  >
    {{ text }}
  </v-alert>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    type: {
      type: String,
      default: 'info'
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>